export default "__VITE_ASSET__Bt58fVcm__"